const TaxCalculation = {
  /**
   * Instantiate tax calculation
   * @param {HTMLElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;
    this.taxPercentage = null;
    this.taxExcludedField = $(this.node).find('.js-tax-excluded');
    this.taxIncludedField = $(this.node).find('.js-tax-included');
    this.taxPercentageField = $(this.node).find('.js-tax-percentage');

    this.changeTaxPercentage();
    this.createListeners();
  },

  /**
   * Create event listeners for the tax calculation
   * @return {void}
   */
  createListeners() {
    this.taxExcludedField.on('change input', () => this.calculatePriceTaxIncluded());
    this.taxIncludedField.on('change input', () => this.calculatePriceTaxExcluded());
    this.taxPercentageField.on('change', () => this.changeTaxPercentage());
  },

  calculatePriceTaxIncluded() {
    const tax = this.taxPercentage / 100 + 1;
    const value = this.taxExcludedField.val() * tax;

    this.taxIncludedField.val(value.toFixed(3));
  },

  calculatePriceTaxExcluded() {
    const tax = this.taxPercentage + 100;
    const value = (this.taxIncludedField.val() / tax) * 100;

    this.taxExcludedField.val(value.toFixed(3));
  },

  changeTaxPercentage() {
    this.taxPercentage = parseInt(this.taxPercentageField.find('option:selected').data('percentage'), 10);

    this.calculatePriceTaxIncluded();
    this.calculatePriceTaxExcluded();
  },
};

export default TaxCalculation;
